import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHashHistory } from 'vue-router'
import type { App } from 'vue'
import { NO_RESET_WHITE_LIST } from '@/constants'
import productRouter from '@/router/modules/product'
import memberRouter from '@/router/modules/member'
import frontOperationRouter from '@/router/modules/frontOperation'
import financeRouter from '@/router/modules/finance'
import orderRouter from '@/router/modules/order'
import stockRouter from '@/router/modules/stock'
import systemRouter from '@/router/modules/system'
import storeRouter from '@/router/modules/store'
import afterSaleRouter from '@/router/modules/afterSale'
import marketingRouter from '@/router/modules/marketing'
import messageRouter from '@/router/modules/message'
import {
  ErrorRouter,
  LoginRouter,
  NoFindRouter,
  PersonalRouter,
  RedirectRouter,
  RootRouter
} from '@/router/modules/base'

export const constantRouterMap: AppRouteRecordRaw[] = [
  RootRouter,
  RedirectRouter,
  LoginRouter,
  PersonalRouter,
  NoFindRouter,
  ErrorRouter
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  memberRouter, // 会员管理
  productRouter, // 产品管理
  stockRouter, // 库存管理
  orderRouter, //订单列表
  afterSaleRouter, // 直销区售后
  marketingRouter, // 营销管理
  financeRouter, // 财务管理
  storeRouter, // 店铺管理
  messageRouter, // 消息管理
  systemRouter, // 系统管理
  frontOperationRouter // 前端装修
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
